/**
 * This file contains the basic building blocks for the product listing page
 */

import { classed } from "@frend-digital/ui";
import styles from "./ProductListingPage.module.css";

export const ProductGrid = classed("section", styles.productGrid);
